export const OPEN_PAGE = 'OPEN_PAGE';

export const openPage = page => ({
    type: OPEN_PAGE,
    payload: page
});
